<template>
  <div class="needsValidation">
    <div class="filter-container">
      <div class="btn-container">
        <el-button class="mb-10 download-btn" type="info" size="small" icon="el-icon-plus" @click="onClickCreateBtn">{{ $t('payment_page.create_new_link') }}</el-button>
      </div>

      <!-- <UploadExcelFile
        :merchant-id="merchantId"
        class="mt5 "
        :limit-num="1"
        @templateFileSuccess="templateFileSuccess"
      /> -->
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <el-table-column :label="$t('customerService.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.creator')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.operate_user_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.reference')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.reference_batch_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.submit_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.submit_quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.total_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount | toThousandFilter }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.validation')" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.validate" type="danger" class="tag-custom">Failed</el-tag>
            <el-tag v-else type="success" class="tag-custom">Passed</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">

            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.submit') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function " icon-class="operation-submit" @click="onClickSubmitReviewBtn(scope.row)" />
            </el-tooltip>

            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.delete') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function " icon-class="operation-delete" @click="onClickDeleteBtn(scope.row.reference_batch_no)" />
            </el-tooltip>

            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row.reference_batch_no)" />
            </el-tooltip>

          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <ChooseCreatePaymentWayModal ref="chooseCreatePaymentWayModal" @getAllReferenceInfo="getAllReferenceInfo" />
  </div>
</template>

<script>

import { fetchPaymentAllRefernceData, paymentRefernceConfirm, deletePaymentRefernceData } from '@/api/online-transaction/online-transaction'
import { rechargeStatusMap } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'

export default {
  name: 'Payment_Needs_Validation',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    ChooseCreatePaymentWayModal: () => import('../Modal/ChooseCreatePaymentWayModal.vue')

  },
  data() {
    return {
      multipleSelection: [],
      rechargeStatusArr: rechargeStatusMap(),
      tableData: [],
      listLoading: false,
      submiting: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  created() {
    this.getAllReferenceInfo()
  },
  methods: {
    getAllReferenceInfo(otherParams) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchPaymentAllRefernceData(params).then(res => {
        if (res.code === 10000) {
          const { total, records = [], current } = res.data
          this.listQuery.total = total
          this.listQuery.page = current
          this.tableData = records
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      let params = { type: 1, status: 0, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    onClickDetailBtn(reference_batch_no) {
      this.$router.push({ name: 'Online_Transaction_Detail_Payin', params: { id: reference_batch_no, status: 0 }})
    },
    onClickDeleteBtn(reference_batch_no) {
      this.$confirm('Delete or not?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        if (this.submiting) {
          return
        }
        this.submiting = true
        const params = {
          reference_batch_no
        }
        deletePaymentRefernceData(params).then(res => {
          if (res.code === 10000) {
            this.$message.success('Delete Successfully!')
            this.getAllReferenceInfo()
          }
        }).finally(() => {
          this.submiting = false
        })
      })
    },
    onClickSubmitReviewBtn(row) {
      this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
        confirmButtonText:  this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        if (this.submiting) {
          return
        }
        this.submiting = true
        const params = {
          reference_batch_no: row.reference_batch_no
        }
        paymentRefernceConfirm(params).then(res => {
          if (res.code === 10000) {
            this.$message.success('Submit Successfully!')
            this.getAllReferenceInfo()
          }
        }).finally(() => {
          this.submiting = false
        })
      })
    },
    onClickCreateBtn() {
      this.$refs.chooseCreatePaymentWayModal.changModalStatus(true)
    },

    onClickPaginator() {

      this.getAllReferenceInfo(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.needsValidation{
   background-color: #fff;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px;
  }
  .btn-container{
    display: flex;
    justify-content: flex-end;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .btn-operation{
    margin-bottom: 10px;
    // width: 100px;
    // display: block;
    // margin: 5px;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
